import actions from './actions'
import days from './days'
import errors from './errors'
import flowEditor from './flowEditor'
import git from './git'
import header from './header'
import hints from './hints'
import labels from './labels'
import months from './months'
import routes from './routes'
import status from './status'
import success from './success'
import themes from './themes'
import visualEditor from './visualEditor'

export default {
  actions,
  days,
  errors,
  flowEditor,
  git,
  header,
  hints,
  labels,
  months,
  routes,
  status,
  success,
  themes,
  visualEditor
}
